import * as Redux from "redux";

export const CHANGE_PROCESS_LIST_ROWS_PER_PAGE = "CHANGE_PROCESS_LIST_ROWS_PER_PAGE";
export function changeProcessListRowsPerPage(rowsPerPage: number): ChangeProcessListRowsPerPageAction {
    return {
        type: CHANGE_PROCESS_LIST_ROWS_PER_PAGE,
        newRowsPerPage: rowsPerPage
    };
}

export interface ChangeProcessListRowsPerPageAction extends Redux.Action {
    newRowsPerPage: number;
}
